import { useEffect, useState } from "react";
import type { MobPersona } from "../api/mob-persona";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "./ui/dialog";
import { Input } from "./ui/input";
import { ScrollArea } from "./ui/scroll-area";

interface MobPersonaModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (id: string) => void;
  personas: MobPersona[];
}

export function MobPersonaModal({ isOpen, onClose, onSelect, personas }: MobPersonaModalProps) {
  const [searchJob, setSearchJob] = useState("");
  const [filteredPersonas, setFilteredPersonas] = useState<MobPersona[]>(personas);

  useEffect(() => {
    if (searchJob) {
      setFilteredPersonas(personas.filter((p) => p.job.toLowerCase().includes(searchJob.toLowerCase())));
    } else {
      setFilteredPersonas(personas);
    }
  }, [searchJob, personas]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>MobPersonaの選択</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <Input placeholder="職業で検索" value={searchJob} onChange={(e) => setSearchJob(e.target.value)} />
          <ScrollArea className="h-[400px]">
            <div className="space-y-2">
              {filteredPersonas.map((persona) => (
                <div
                  key={persona.id}
                  className="p-4 border rounded-lg hover:bg-gray-50 cursor-pointer"
                  onClick={() => onSelect(persona.id)}
                >
                  <div className="font-bold">{persona.name}</div>
                  <div className="text-sm text-gray-600">
                    {persona.gender === "male" ? "男性" : persona.gender === "female" ? "女性" : "その他"} /{" "}
                    {persona.age}歳 / {persona.job}
                  </div>
                </div>
              ))}
            </div>
          </ScrollArea>
        </div>
        <DialogFooter>
          <Button onClick={onClose} variant="outline">
            キャンセル
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
